module.exports = __webpack_public_path__ + "static/favicon-3c6354b6f023b4213b5d4c31bb213ba5.ico";